// import React, { useState, useEffect } from "react";
// import "./ProjectToolbar.css";

// const ProjectToolbar = ({
//   viewMode,
//   onViewModeChange,
//   onSearch,
//   onStatusChange,
//   statusFilter = "Tất cả hợp đồng",
//   initialSearchTerm = "",
//   onAddContract,
// }) => {
//   const [searchInput, setSearchInput] = useState(initialSearchTerm);

//   // Cập nhật searchInput khi initialSearchTerm thay đổi
//   useEffect(() => {
//     setSearchInput(initialSearchTerm);
//   }, [initialSearchTerm]);

//   const handleSearchChange = (e) => {
//     setSearchInput(e.target.value);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     onSearch(searchInput);
//   };

//   return (
//     <div className="project-toolbar">
//       <div className="toolbar-left">
//         <div className="search-box">
//           {" "}
//           <form onSubmit={handleSearchSubmit}>
//             <input
//               type="text"
//               placeholder="Tìm kiếm hợp đồng..."
//               value={searchInput}
//               onChange={handleSearchChange}
//             />
//             <button type="submit">
//               <span className="material-icons">search</span>
//             </button>
//           </form>
//         </div>{" "}
//         <div className="filter-box">
//           <select
//             className="filter-button"
//             onChange={(e) => {

//               onStatusChange(e.target.value);
//             }}
//             value={statusFilter}
//           >
//             <option value="Tất cả hợp đồng">Tất cả hợp đồng</option>
//             <option value="Chưa bắt đầu">Chưa bắt đầu</option>
//             <option value="Đang thực hiện">Đang thực hiện</option>
//             <option value="Hoàn thành">Hoàn thành</option>
//             <option value="Tạm dừng">Tạm dừng</option>
//             <option value="Hủy bỏ">Hủy bỏ</option>
//           </select>
//         </div>
//       </div>{" "}
//       <div className="toolbar-right">
//         <button className="add-project-btn" onClick={onAddContract}>
//           <span className="material-icons">add</span>
//           Thêm hợp đồng
//         </button>
//         <div className="view-toggle">
//           <button
//             className={`toggle-btn ${viewMode === "grid" ? "active" : ""}`}
//             onClick={() => onViewModeChange("grid")}
//           >
//             <span className="material-icons">grid_view</span>
//           </button>
//           <button
//             className={`toggle-btn ${viewMode === "list" ? "active" : ""}`}
//             onClick={() => onViewModeChange("list")}
//           >
//             <span className="material-icons">view_list</span>
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProjectToolbar;

import React, { useState, useEffect } from "react";
import { AppButton } from "components/common/buttons";
import { AppTextField, AppSelect } from "components/common/inputs";
import { AppFilterBar } from "components/common/filters";
import "./ProjectToolbar.css";
import {
  ViewList as ViewListIcon,
  Search as SearchIcon,
  GridView as GridViewIcon,
} from "@mui/icons-material";

const statusOptions = [
  { value: "Tất cả hợp đồng", label: "Tất cả hợp đồng" },
  { value: "Chưa bắt đầu", label: "Chưa bắt đầu" },
  { value: "Đang thực hiện", label: "Đang thực hiện" },
  { value: "Hoàn thành", label: "Hoàn thành" },
  { value: "Tạm dừng", label: "Tạm dừng" },
  { value: "Hủy bỏ", label: "Hủy bỏ" },
];

const ProjectToolbar = ({
  viewMode,
  onViewModeChange,
  onSearch,
  onStatusChange,
  statusFilter = "Tất cả hợp đồng",
  initialSearchTerm = "",
  onAddContract,
}) => {
  const [searchInput, setSearchInput] = useState(initialSearchTerm);

  // Cập nhật searchInput khi initialSearchTerm thay đổi
  useEffect(() => {
    setSearchInput(initialSearchTerm);
  }, [initialSearchTerm]);

  const handleSearchChange = (value) => {
    setSearchInput(typeof value === "object" ? value?.target?.value : value);
  };

  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();
    onSearch(searchInput);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchSubmit(e);
    }
  };

  return (
    <AppFilterBar icon={false}>
      <AppTextField
        placeholder="Tìm kiếm hợp đồng ..."
        value={searchInput}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
        sx={{ flex: 1 }}
      />
      <AppButton variant="outlined" onClick={handleSearchSubmit}>
        <SearchIcon />
      </AppButton>
      <AppSelect
        label="Trạng thái"
        value={statusFilter}
        options={statusOptions}
        onChange={(value) => {
          onStatusChange(value);
        }}
        sx={{ minWidth: 180, flex: 1 }}
      />
      <AppButton
        variant="contained"
        color="primary"
        onClick={onAddContract}
        startIcon={<span className="material-icons">add</span>}
        disableElevation
      >
        Thêm hợp đồng
      </AppButton>

      <AppButton
        variant={viewMode === "grid" ? "contained" : "outlined"}
        onClick={() => onViewModeChange("grid")}
      >
        {/* <span className="material-icons">grid_view</span> */}
        <GridViewIcon />
      </AppButton>

      <AppButton
        variant={viewMode === "list" ? "contained" : "outlined"}
        onClick={() => onViewModeChange("list")}
      >
        {/* <span className="material-icons">view_list</span> */}
        <ViewListIcon />
      </AppButton>
    </AppFilterBar>
  );
};

export default ProjectToolbar;
